// Import all required JavaScript here.
// This includes govuk-frontend, hmpo-components, and any custom scripts for your app.
// Rollup will bundle everything imported in this file.
// Add your custom JavaScript imports below as needed.

import { initAll } from 'govuk-frontend';
import 'hmpo-components/all.js';
import './session-timeout-dialog.js';

// Initialize GOV.UK Frontend
initAll();
